import utils from './utils';

const fetchRetailersBySource= async (source) => {
  const FETCH_OPTIONS = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  };
  const safegraphRetailersFetch = await fetch(`${utils.availabilityUrl()}/${source}/retailers/query`, FETCH_OPTIONS);
  const response = await safegraphRetailersFetch.json();

  return response;
};

export const getAllRetailersFromLocationApi = async () => {
  try {
    const sources = ['safegraph', 'firestore'];
    const sourcesResponse = await Promise.all(
      sources.map((source) => fetchRetailersBySource(source)));

    // combine all responses
    const combinedResponse = sourcesResponse.reduce((mergedResponse, currResponse) => {
      mergedResponse = {
        ...mergedResponse,
        ...currResponse,
        // all responses need to return success or else we consider all responses false
        // we do this cause we need to show ALL the retailers from the different sources
        success: currResponse.success && mergedResponse.success,
        retailers: [...mergedResponse.retailers, ...currResponse.retailers],
      };

      return mergedResponse;
    }, { success: true, retailers: [] });

    return combinedResponse;
  } catch (e) {
    return ({ success: false, error: e.message });
  }
};

export const associateRetailer = async (retailerId, mikMakRetailerId, source) => {
  try {
    const reqBody = JSON.stringify({ retailerId, mikMakRetailerId });
    const response =
      await fetch(`${utils.availabilityUrl()}/${source.toLowerCase()}/retailers/associate`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: reqBody,
        });

    const parsedResponse = await response.json();

    if (!parsedResponse.success) {
      return { error: parsedResponse.error, success: false };
    }

    return parsedResponse;
  } catch (e) {
    return ({ success: false, error: e.message });
  }
};

export const dissociateRetailer = async (retailerId, source) => {
  try {
    const reqBody = JSON.stringify({ retailerId });
    const response =
      await fetch(`${utils.availabilityUrl()}/${source.toLowerCase()}/retailers/dissociate`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: reqBody,
        });

    const parsedResponse = await response.json();

    if (!parsedResponse.success) {
      return { error: parsedResponse.error, success: false };
    }

    return parsedResponse;
  } catch (e) {
    return ({ success: false, error: e.message });
  }
};

export const setStoresbyCartId = async (cartId) => {
  try {
    const response =
      await fetch(`${utils.availabilityUrl()}/set-stores/${cartId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

    const parsedResponse = await response.json();

    if (!parsedResponse.success) {
      return { error: parsedResponse.message, success: false };
    }

    return parsedResponse;
  } catch (e) {
    return ({ success: false, error: e.message });
  }
};

export const deleteStoresbyCartId = async (cartId) => {
  try {
    const response =
      await fetch(`${utils.availabilityUrl()}/delete-stores/${cartId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

    const parsedResponse = await response.json();

    if (!parsedResponse.success) {
      return { error: parsedResponse.message, success: false };
    }

    return parsedResponse;
  } catch (e) {
    return ({ success: false, error: e.message });
  }
};
